const initialState = {
  data:{},
  search:'',
  filter:{
    type: 0,
    priceMin: 0,
    priceMax: 0,
    pricePerMin: 0,
    pricePerMax: 0,
    capBanMin: 0,
    capBanMax: 0,
    capFurMin: 0,
    capFurMax: 0
  },
  sort:{
    field:'place_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_PLACES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_PLACES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_PLACES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_PLACES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_PLACE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.place_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/places.js